import { createStore, StoreOptions } from 'vuex';
import { apiService } from '../api/apiService';

interface RootState {
  isAuthenticated: boolean;
  user: any | null;
  setting: any | null;
  sedeSelezionata: any | null;
  authToken: string | null;
  sidebarVisible: boolean;
  sidebarUnfoldable: boolean;
}

enum MutationTypes {
  SET_AUTHENTICATED = 'SET_AUTHENTICATED',
  SET_USER = 'SET_USER',
  SET_SETTING = 'SET_SETTING',
  SET_SEDESELEZIONATA = 'SET_SEDESELEZIONATA',
  SET_AUTH_TOKEN = 'SET_AUTH_TOKEN',
}

// Sidebar mutations (usate direttamente per nome stringa)
function toggleSidebar(state: RootState) {
  state.sidebarVisible = !state.sidebarVisible
}
function updateSidebarVisible(state: RootState, val: boolean) {
  state.sidebarVisible = val
}
function toggleUnfoldable(state: RootState) {
  state.sidebarUnfoldable = !state.sidebarUnfoldable
}

interface Mutations {
  [MutationTypes.SET_AUTHENTICATED](state: RootState, payload: boolean): void;
  [MutationTypes.SET_USER](state: RootState, payload: any | null): void;
  [MutationTypes.SET_SETTING](state: RootState, payload: any | null): void;
  [MutationTypes.SET_SEDESELEZIONATA](state: RootState, payload: any | null): void;
  [MutationTypes.SET_AUTH_TOKEN](state: RootState, payload: string | null): void; // Aggiungi per il token (opzionale)
}

const mutations: Mutations = {
  [MutationTypes.SET_AUTHENTICATED](state, payload) {
    state.isAuthenticated = payload;
  },
  [MutationTypes.SET_USER](state, payload) {
    state.user = payload;
  },
  [MutationTypes.SET_SETTING](state, payload) {
    state.setting = payload;
  },
  [MutationTypes.SET_SEDESELEZIONATA](state, payload) {
    state.sedeSelezionata = payload;
  },
  [MutationTypes.SET_AUTH_TOKEN](state, payload) { // Aggiungi per il token (opzionale)
    state.authToken = payload;
  },
};

export enum ActionTypes {
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
    CHECK_AUTH_ON_LOAD = 'CHECK_AUTH_ON_LOAD', // Nuova azione
    FETCH_SETTINGS = 'FETCH_SETTINGS', // Nuova azione per caricare i settings
    // ...
  }

interface Actions {
    [ActionTypes.LOGIN](context: { commit: Function }, credentials: any): Promise<any>;
    [ActionTypes.LOGOUT](context: { commit: Function }, router: any): void; // Passa il router se necessario
    [ActionTypes.CHECK_AUTH_ON_LOAD](context: { commit: Function }): void; // Nuova azione
    [ActionTypes.FETCH_SETTINGS](context: { commit: Function }): Promise<any>; // Nuova azione per caricare i settings
}

const actions: Actions = {
  async [ActionTypes.LOGIN]({ commit }, data) {
    try {
      // Fai la chiamata API di login a Laravel
      /* 
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Errore durante il login');
      }

      const data = await response.json();
      const token = data.token; // Assumi che la risposta contenga un token
      const user = data.user;   // Assumi che la risposta contenga i dati dell'utente
 */

      
      const token = data.access_token
      const user= JSON.stringify(data.user)
      const sedeSelezionata= {descrizione:data.user.sedeDescrizione,codice:data.user.sedeCodice}

      // Commetti le mutazioni per aggiornare lo stato
      commit(MutationTypes.SET_AUTHENTICATED, true);
      commit(MutationTypes.SET_USER, user);
      commit(MutationTypes.SET_SEDESELEZIONATA, JSON.stringify(sedeSelezionata));
      commit(MutationTypes.SET_AUTH_TOKEN, token); // Salva il token nello store (opzionale)

      // Potresti anche salvare il token nel localStorage o sessionStorage qui
      localStorage.setItem('authToken', token);
      localStorage.setItem('user',user);
      localStorage.setItem('sedeSelezionata',JSON.stringify(sedeSelezionata));

      return data; // Restituisci i dati se necessario
    } catch (error: any) {
      console.error('Errore durante il login:', error.message);
      throw error;
    }
  },
  async [ActionTypes.LOGOUT]({ commit }, router) {
    commit(MutationTypes.SET_AUTHENTICATED, false);
    commit(MutationTypes.SET_SEDESELEZIONATA, null);
    commit(MutationTypes.SET_USER, null);
    commit(MutationTypes.SET_AUTH_TOKEN, null);
    localStorage.removeItem('authToken');
    // Reindirizza alla pagina di login se necessario
    if (router) {
      router.push({ name: 'login' });
    }
  },
  [ActionTypes.CHECK_AUTH_ON_LOAD]({ commit }) {
    const token = localStorage.getItem('authToken');
    if (token) {
      // Qui potresti anche fare una chiamata API per validare il token e recuperare i dati dell'utente
      // Per ora, impostiamo semplicemente isAuthenticated a true e potresti recuperare
      // i dati dell'utente in un'altra azione se necessario.
      commit(MutationTypes.SET_AUTHENTICATED, true);
      // Se hai salvato anche i dati dell'utente nel localStorage, potresti ripristinarli qui.
       const storedUser = localStorage.getItem('user');
       if (storedUser) {
         commit(MutationTypes.SET_USER, (storedUser));
        // commit(MutationTypes.SET_USER, JSON.parse(storedUser));
       }
      commit(MutationTypes.SET_AUTH_TOKEN, token);
      
      // Carica anche i settings dal localStorage se presenti
      const storedSettings = localStorage.getItem('setting');
      if (storedSettings) {
        try {
          commit(MutationTypes.SET_SETTING, JSON.parse(storedSettings));
        } catch (e) {
          console.error('Errore nel parsing dei settings dal localStorage', e);
        }
      }
    } else {
      commit(MutationTypes.SET_AUTHENTICATED, false);
      commit(MutationTypes.SET_USER, null);
      commit(MutationTypes.SET_AUTH_TOKEN, null);
    }
  },
  async [ActionTypes.FETCH_SETTINGS]({ commit }) {
    try {
        console.log('entro FETCH_SETTINGS:');

      // Chiama l'API per ottenere i settings
      const settings = await apiService.settingGet();
      
      if (settings) {
        // Salva i settings nello store
        commit(MutationTypes.SET_SETTING, settings);
        
        // Salva anche nel localStorage per persistenza
        localStorage.setItem('setting', JSON.stringify(settings));
        
        console.log('Settings caricati con successo:', settings);
        return settings;
      }
    } catch (error: any) {
      console.error('Errore durante il caricamento dei settings:', error);
      throw error;
    }
  },
  // ...
};

const store = createStore<RootState>({
  state: {
    isAuthenticated: false,
    user: null,
    setting: null,
    sedeSelezionata: null,
    authToken: null,
    sidebarVisible: true,
    sidebarUnfoldable: false,
  },
  mutations: {
    ...mutations,
    toggleSidebar,
    updateSidebarVisible,
    toggleUnfoldable,
  },
  actions,
  // ...
});

export default store;